/*
 * FESCHD Gratisartikel-Modul (Cart-Drawer)
 *
 * ZWEI GETRENNTE FUNKTIONEN (siehe snippets/feschd-free-gift.liquid):
 * - STANDARD (immer aktiv, KEIN UI): Bundle aus der Kollektion "Gratis
 *   Trinkflasche" im Warenkorb (Template-Suffix feschd-highconverting oder
 *   feschd-lichtbundle) -> Trinkflasche wird automatisch als normale
 *   Warenkorbzeile hinzugefügt (Auto-Add). Der 0-€-Preis kommt vom
 *   automatischen Bxgy-Rabatt "Gratis Trinkflasche" (Kollektions-Bedingung).
 *   Entfernt der Kunde die Flasche über die Warenkorbzeile, merkt sich das
 *   Modul per sessionStorage, dass bereits auto-hinzugefügt wurde, und legt
 *   sie nicht erneut hinein (kein Abwahl-Button mehr -> sonst Endlosschleife).
 * - AKTIONS-MODUS (gift_enabled an, sichtbares UI): Schwellen-Wahlsystem
 *   (Stufe 1 -> 1 Artikel, Stufe 2 -> 2 Artikel, Tier-2-Sperre).
 *
 * TRIGGER für die Konsistenzprüfung (evaluate):
 * - Initial beim Laden der Seite
 * - Prestige-Events 'cart:change' und 'cart:refresh' auf document
 * - MutationObserver: erkennt, wenn der Drawer (und damit #feschd-free-gift)
 *   neu gerendert wird. Wichtig, weil die Custom-PDP-Buttons (feschd-Templates)
 *   ihren eigenen Add-to-Cart-Flow haben und nicht zwingend Theme-Events feuern.
 *
 * Weitere Aufgaben von evaluate():
 * - Erlaubte Anzahl: Aktions-Schwellen-Logik; Bundle im Warenkorb -> min. 1.
 * - Tier-2-Artikel fliegen raus, wenn Stufe 2 unterschritten wird (nur Aktion).
 * - Bei zu vielen Geschenken werden die ZULETZT hinzugefügten entfernt
 *   (cart.items ist neueste zuerst) -> die erste Wahl des Kunden bleibt.
 * - Menge jedes Geschenks immer 1.
 * - Kein Modus aktiv, aber Geschenke im Cart (z. B. Bundle entfernt)
 *   -> Geschenke werden entfernt (allowed = 0).
 * - Auto-Add nur, wenn weder abgewählt noch bereits auto-hinzugefügt (Session);
 *   das Auto-Added-Flag wird erst bei ERFOLGREICHEM Add gesetzt.
 * - Verschwindet der Bundle-Trigger, werden beide Session-Flags gelöscht.
 * Nach eigenen Änderungen wird der Prestige-Drawer per 'cart:refresh' neu
 * gerendert.
 */
(function () {
  if (window.FeschdFreeGift) return;
  window.FeschdFreeGift = true;

  var busy = false;
  var evaluateTimer = null;
  var OPTOUT_KEY = 'feschdGiftOptout';
  var AUTOADDED_KEY = 'feschdGiftAutoAdded';

  function getModule() {
    return document.getElementById('feschd-free-gift');
  }

  function setBusy(state) {
    busy = state;
    var mod = getModule();
    if (mod) mod.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function optedOut() {
    try { return sessionStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }

  function setOptout() {
    try { sessionStorage.setItem(OPTOUT_KEY, '1'); } catch (e) { /* egal */ }
  }

  function wasAutoAdded() {
    try { return sessionStorage.getItem(AUTOADDED_KEY) === '1'; } catch (e) { return false; }
  }

  function setAutoAdded() {
    try { sessionStorage.setItem(AUTOADDED_KEY, '1'); } catch (e) { /* egal */ }
  }

  function clearSessionFlags() {
    try {
      sessionStorage.removeItem(OPTOUT_KEY);
      sessionStorage.removeItem(AUTOADDED_KEY);
    } catch (e) { /* egal */ }
  }

  function readConfig(mod) {
    var tier2 = (mod.dataset.tier2Variants || '')
      .split(',')
      .map(function (s) { return Number(s); })
      .filter(function (n) { return n > 0; });

    return {
      threshold1: Number(mod.dataset.threshold),
      threshold2: Number(mod.dataset.threshold2 || 0),
      tier2Variants: tier2,
      autoAddVariant: Number(mod.dataset.autoaddVariant || 0),
      actionActive: mod.dataset.actionActive === '1'
    };
  }

  function allowedCount(total, cfg) {
    var allowed = 0;
    if (cfg.actionActive) {
      if (cfg.threshold2 > 0 && total >= cfg.threshold2) {
        allowed = 2;
      } else if (total >= cfg.threshold1) {
        allowed = 1;
      }
    }
    // Standard: Bundle im Warenkorb -> mindestens 1 Gratisartikel
    if (cfg.autoAddVariant > 0 && allowed < 1) {
      allowed = 1;
    }
    return allowed;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function isGift(item) {
    return item.properties && item.properties._feschd_gift;
  }

  function giftLines(cart) {
    return cart.items.filter(isGift); // Reihenfolge: neueste zuerst
  }

  function qualifyingTotal(cart) {
    return cart.items
      .filter(function (i) { return !isGift(i); })
      .reduce(function (sum, i) { return sum + i.final_line_price; }, 0);
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function addGift(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _feschd_gift: 'true' } }]
      })
    });
  }

  function refreshTheme() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function runSequential(operations) {
    return operations.reduce(function (chain, op) {
      return chain.then(op);
    }, Promise.resolve());
  }

  /* Entprellt evaluate() – mehrere Trigger kurz hintereinander (Events +
     MutationObserver beim Re-Render) laufen so nur einmal. */
  function scheduleEvaluate() {
    clearTimeout(evaluateTimer);
    evaluateTimer = setTimeout(evaluate, 120);
  }

  /* Konsistenz erzwingen (Modus, Schwellen, Anzahl, Tier-2-Sperre, Menge, Auto-Add) */
  function evaluate() {
    var mod = getModule();
    if (!mod) return;
    if (busy) { scheduleEvaluate(); return; }

    var cfg = readConfig(mod);

    // Kein Bundle (mehr) im Warenkorb -> Session-Merkungen zurücksetzen,
    // damit ein späterer Bundle-Kauf wieder normal ausgestattet wird.
    if (cfg.autoAddVariant === 0) clearSessionFlags();

    setBusy(true);
    fetchCart()
      .then(function (cart) {
        var total = qualifyingTotal(cart);
        var allowed = allowedCount(total, cfg);
        var gifts = giftLines(cart);
        var operations = [];
        var keep = [];

        // 1) Tier-2-Artikel entfernen, wenn Stufe 2 nicht (mehr) erreicht ist
        gifts.forEach(function (g) {
          var isTier2 = cfg.tier2Variants.indexOf(g.variant_id) !== -1;
          var tier2Reached = cfg.actionActive && cfg.threshold2 > 0 && total >= cfg.threshold2;
          if (isTier2 && !tier2Reached) {
            operations.push(function () { return changeLine(g.key, 0); });
          } else {
            keep.push(g);
          }
        });

        // 2) Zu viele Geschenke: neueste zuerst entfernen (Index 0 = zuletzt hinzugefügt)
        while (keep.length > allowed) {
          var newest = keep.shift();
          (function (g) {
            operations.push(function () { return changeLine(g.key, 0); });
          })(newest);
        }

        // 3) Menge je Geschenk auf 1 begrenzen
        keep.forEach(function (g) {
          if (g.quantity > 1) {
            operations.push(function () { return changeLine(g.key, 1); });
          }
        });

        // 4) Auto-Add: Bundle im Warenkorb, noch kein Geschenk im Cart,
        //    keine manuelle Abwahl UND noch nicht auto-hinzugefügt in dieser
        //    Session. Flag erst bei erfolgreichem Add setzen, damit ein
        //    fehlgeschlagener Versuch keine weiteren blockiert.
        if (cfg.autoAddVariant > 0 && allowed > 0 && keep.length === 0 && !optedOut() && !wasAutoAdded()) {
          operations.push(function () {
            return addGift(cfg.autoAddVariant).then(function (r) {
              if (r && r.ok) setAutoAdded();
              return r;
            });
          });
        }

        if (!operations.length) {
          setBusy(false);
          return;
        }

        return runSequential(operations).then(function () {
          setBusy(false);
          refreshTheme();
        });
      })
      .catch(function () { setBusy(false); });
  }

  /* Klick auf eine Geschenk-Option (nur Aktions-UI; Event-Delegation, überlebt Re-Renders) */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-feschd-gift-option]');
    if (!button || button.disabled) return;

    var mod = getModule();
    if (!mod || busy) return;

    event.preventDefault();

    var cfg = readConfig(mod);
    var chosenVariantId = Number(button.dataset.variantId);

    setBusy(true);
    fetchCart()
      .then(function (cart) {
        var total = qualifyingTotal(cart);
        var allowed = allowedCount(total, cfg);
        var gifts = giftLines(cart);
        var operations = [];

        var existing = gifts.find(function (g) { return g.variant_id === chosenVariantId; });

        if (existing) {
          // Abwählen: gewählten Artikel wieder entfernen + für die Session merken,
          // damit der Auto-Add ihn nicht sofort wieder hinzufügt
          setOptout();
          operations.push(function () { return changeLine(existing.key, 0); });
        } else {
          var isTier2 = cfg.tier2Variants.indexOf(chosenVariantId) !== -1;
          var tier2Reached = cfg.actionActive && cfg.threshold2 > 0 && total >= cfg.threshold2;

          if (allowed === 0) { setBusy(false); return; }
          if (isTier2 && !tier2Reached) { setBusy(false); return; }

          if (gifts.length < allowed) {
            operations.push(function () { return addGift(chosenVariantId); });
          } else if (allowed === 1 && gifts.length === 1) {
            // Direkt tauschen, wenn nur 1 Geschenk erlaubt ist
            var current = gifts[0];
            operations.push(function () { return changeLine(current.key, 0); });
            operations.push(function () { return addGift(chosenVariantId); });
          } else {
            // Maximum erreicht: Kunde muss zuerst abwählen (Hinweis im UI)
            setBusy(false);
            return;
          }
        }

        return runSequential(operations).then(function () {
          setBusy(false);
          refreshTheme();
        });
      })
      .catch(function () { setBusy(false); });
  });

  /* Auf Warenkorbänderungen des Themes reagieren (Prestige-Events) */
  document.addEventListener('cart:change', scheduleEvaluate);
  document.addEventListener('cart:refresh', scheduleEvaluate);

  /* Re-Render des Drawers erkennen – fängt auch Custom-Add-to-Cart-Flows ab,
     die keine Theme-Events feuern (z. B. die feschd-PDP-Buttons). */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.id === 'feschd-free-gift' || (node.querySelector && node.querySelector('#feschd-free-gift'))) {
          scheduleEvaluate();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }
})();
